import PropTypes from 'prop-types';
import React, {useState, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {Chip, Divider, Grid, Paper, Toolbar, Typography} from '@material-ui/core';
import {debounce} from 'throttle-debounce';
import {findUsers} from 'UserLobby/service/UserService';
import UserList from 'UserLobby/components/UserList';
import UserProperties from 'UserLobby/components/UserProperties';
import Loader from 'util/Loader';

export default function UserLobbyView(props, context) {
  const {router} = context;
  const {
    location: {
      query: {fullNameFilterText = '', usernameFilterText = '', dateFilterText = ''},
    },
  } = props;
  const decodedUsernameFilterText = decodeURIComponent(usernameFilterText);
  const decodedFullNameFilterText = decodeURIComponent(fullNameFilterText);
  const decodedDateFilterText = decodeURIComponent(dateFilterText);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const handleChangeUsernameFilterText = debounce(1000, (filterText) => {
    const {
      location: {pathname, query: oldQuery},
    } = props;
    const query = {...oldQuery};

    if (!!filterText) {
      query.usernameFilterText = encodeURIComponent(filterText);
    } else {
      delete query.usernameFilterText;
    }

    router.replace({pathname, query});
  });
  const handleChangeFullNameFilterText = debounce(1000, (filterText) => {
    const {
      location: {pathname, query: oldQuery},
    } = props;
    const query = {...oldQuery};

    if (!!filterText) {
      query.fullNameFilterText = encodeURIComponent(filterText);
    } else {
      delete query.fullNameFilterText;
    }

    router.replace({pathname, query});
  });
  const handleChangeDateFilterText = debounce(1000, (filterText) => {
    const {
      location: {pathname, query: oldQuery},
    } = props;
    const query = {...oldQuery};

    if (!!filterText) {
      query.dateFilterText = encodeURIComponent(filterText);
    } else {
      delete query.dateFilterText;
    }

    router.replace({pathname, query});
  });
  const handleChangeSelectedUser = (user) => {
    setSelectedUser(user);
  };

  useEffect(() => {
    const handleRetrieveUsers = async () => {
      const users = await findUsers();

      setUsers(users);
      setIsLoading(false);
    };

    if (isLoading) {
      handleRetrieveUsers();
    }
  }, [isLoading]);

  return (
    <>
      <Helmet title="Users" defer={false} />
      <Grid container spacing={2}>
        <Grid item xs={8} md={9}>
          <Paper>
            <Toolbar>
              <Typography style={{color: 'grey'}} variant="h5">
                User Lobby
              </Typography>
              <Chip style={{marginLeft: 30}} variant="outlined" label={users.length} />
            </Toolbar>
            <Divider />
            {isLoading ? (
              <Loader label="Loading Users..." />
            ) : (
              <UserList
                users={users}
                onChangeSelection={handleChangeSelectedUser}
                usernameFilterText={decodedUsernameFilterText}
                fullNameFilterText={decodedFullNameFilterText}
                dateFilterText={decodedDateFilterText}
                onChangeUsernameFilterText={handleChangeUsernameFilterText}
                onChangeFullNameFilterText={handleChangeFullNameFilterText}
                onChangeDateFilterText={handleChangeDateFilterText}
              />
            )}
          </Paper>
        </Grid>
        {!isLoading && (
          <Grid item xs={4} md={3}>
            <UserProperties selectedUser={selectedUser} />
          </Grid>
        )}
      </Grid>
    </>
  );
}

UserLobbyView.propTypes = {
  location: PropTypes.object.isRequired,
  params: PropTypes.object,
};

UserLobbyView.contextTypes = {
  router: PropTypes.object.isRequired,
};

UserLobbyView.defaultProps = {
  params: null,
};
